import { isObject } from "@pineapplelab/util";
import { FBase } from "./FBase";
import { Language } from "../utils/language";
import { DocumentReference } from "firebase/firestore";
import { MediaLibraryFile } from "../enums/mediaLibraryFileType.enum";
import { ISubtitleMetadata } from "./util/subtitleMetadata";

// TODO: change all "video" occurrences to "media" or "file" or something like that
export class Video extends FBase {

	video: string = null;
	language: Language = null;
	fileName: string = null;
	duration: number = null;
	fileSize: string = null;
	thumbnail: string = null;
	nameLowercase: string = null;
	createdByAdmin: boolean = false;
	uploaded: boolean = false;
	assignedTo: DocumentReference[] = [];
	description: string = null;
	fileType: MediaLibraryFile = null;
	videoHls: string = null;

	__file: File = null;
	__fileThumbnail: File = null;
	__fileUploadProgress: number = null;
	__editFileNameTitle: boolean = false;
	__previousFileName: string = null;
	__fileExtension: string = null;
	__subtitles: ISubtitleMetadata[] = [];

	constructor(json?: { [key: string]: any }) {
		super();
		if (isObject(json)) {
			this.fromJson(json);
		}
	}

	get assigned(): boolean {
		if (!this.assignedTo || !Array.isArray(this.assignedTo)) {
			return false;
		}
		return this.assignedTo.length > 0;
	}

}
export namespace Video {

	export const PATH = 'videos';
	export const SUBTITLES_PATH = 'subtitles';
	// TODO: cuando se agregue o se defina usar paging se debe descomentar
	// export const PAGING = new Paging<Video>(<Paging.IPaging>{
	//   collection: PATH,
	//   orderOptions: [],
	// });

  }
